import React from "react";
import Knight from "../../Knight";
import separator5 from "../../shapes/separator-5.svg";
import SectionTitle from "../components/SectionTitle";

export default function AboutSection() {
  return (
    <div className="section flex w-full shrink-0 flex-col">
      <div className="container about-section relative col-center flex h-auto min-h-0 w-full flex-1 flex-col lg:h-full">
        <SectionTitle title="About" className="mt-10 shrink-0" />
        <div className="flex min-h-0 w-full flex-1 flex-col lg:flex-row lg:items-stretch">
          <div className="flex flex-col self-start mt-40 ml-10 w-3/4 text-left lg:w-1/2">
            <div className="flex flex-col text-left">
              <h2 className="text-xl text-pal-green">Personality</h2>
              <p>
                The best formal way to describe my personality to a complete
                stranger is the Myers-Briggs personality test. The test
                classified my personality type as{" "}
                <span className="text-pal-blue">(ENFJ-A)</span> also known as
                "The Protagonist" Protagonists are natural-born leaders
                passionate and charismatic. Protagonists take a great deal of
                pride in guiding others to work together to improve themselves
                and the community around them. If i wanted to add a more
                personal touch to this accurate description, I would say that i
                have an unhealthy obsession with success and becoming the
                founder of unicorn startup.
              </p>
              <a
                className="text-pal-green  text-xs lg:text-sm"
                href="https://www.16personalities.com/enfj-personality"
                target="__blank"
              >
                {`< source: www.16personalities.com >`}
              </a>
            </div>
            <div className="flex flex-col text-left">
              <h2 className="text-xl text-pal-green mt-10">Education</h2>
              <p>
                I graduated with honours in Software Engineering from the
                University of Malaya which is ranked:
                <br />
                <span className="text-pal-blue">#1</span> in Malaysia and
                <br />
                <span className="text-pal-blue">#58</span> Worldwide
              </p>
              <a
                className="text-pal-green text-xs lg:text-sm"
                href="https://www.topuniversities.com/universities/universiti-malaya-um"
                target="__blank"
              >
                {`< source: www.topuniversities.com >`}
              </a>
            </div>
          </div>
          <div className="relative flex w-full flex-1 flex-col items-center justify-end px-4 pt-10 pb-8 lg:w-1/2 lg:px-0 lg:pt-40 lg:pb-10">
            <div className="knight-about-panel relative z-10 inline-flex w-full flex-col items-center lg:inline-flex">
              <div className="knight-about-backdrop" aria-hidden />
              <div className="relative z-10 w-full">
                <div className="codec-shell__crt knight-about-crt">
                  <div className="hero-face-wrap">
                    <div className="hero-face-glitch">
                      <div className="hero-face-glitch__channel hero-face-glitch__channel--cyan">
                        <Knight className="hero-face-svg" animate={false} />
                      </div>
                      <div className="hero-face-glitch__channel hero-face-glitch__channel--magenta">
                        <Knight className="hero-face-svg" animate={false} />
                      </div>
                      <Knight className="hero-face-glitch__base hero-face-svg" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="about-section-separator about-section-separator--below-about pointer-events-none z-10 box-border w-full select-none"
        style={{
          backgroundImage: `url(${separator5})`,
        }}
        aria-hidden
      />
    </div>
  );
}
